import styled from "styled-components";
export const DateRangeWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  CustomDateRange {
    margin-left: ${({ theme }) => theme?.utilities?.spacing?.["space-sm"]};
  }
`;
